import { BreadcrumbItem } from '@mitsubishi/shared/ui';

import { Selector } from '@ngxs/store';

import { ProjectBreadcrumbsState } from './breadcrumbs.state';

export class ProjectBreadcrumbsSelectors {
  @Selector([ProjectBreadcrumbsState])
  static getProjectBreadCrumbs(state: BreadcrumbItem[]) {
    return state;
  }
}
